import moment from "moment";
import { formatExeclCommon, formatExeclNormalPercent, nullToRung } from '@/pages/dashboard/utils/utils';
import { buildExcelColumns, exportExcel, formatNum, formatPercentNum, unitConversion } from "@/pages/dashboard/utils/utils";

function decimalPlaces(format: string = '') {
  return (format.split('.')[1] ?? '').length
}

function formatVal(val: string | number = '', format: string, unit: string = '') {
  val = val ?? ''
  format = format?.trim() ?? ''

  if (format.includes('%')) {
    val = formatPercentNum(parseFloat(val), decimalPlaces(format.replace('%', '')))
  } else if (format === '0.00') {
    val = formatNum(val)
  } else if (format === '0') {
    val = formatNum(parseFloat(val), !!unit, format === '0')
  }

  return '' + val
}

const getChartAndTableOpt = (data, tableColumns) => {
  return {
    chart: data?.chartData || [],
    table: {
      option: tableColumns,
      data: data?.tableData || [],
      downloadData: data?.downloadData || []
    },
  }
};

const getTrendsChartData = (competitorIdList, dataList, isDayOrWeek, switchDatePicker) => {
  const timeStr = isDayOrWeek ? 'YYYY-MM-DD' : 'YYYY-MM';
  dataList.forEach(item => {
    if (!switchDatePicker) {
      item.date = moment(item.date).format(timeStr)
    }
  });

  const dataListArr: any[] = [];
  for (let i = 0; i < competitorIdList?.length; i++) {
    const dauDataItem = dataList.filter(items => items.unified_id === competitorIdList[i]) || [];
    // 如果length为0，则代表无数据，无数据不添加到list，不参与渲染
    dauDataItem?.length > 0 && dataListArr.push(dauDataItem)
  }
  const chartData = dataListArr?.map(item => {
    const dataArr = item?.map(items => { return { x: items?.date, y: items?.value } }) || [];
    return {
      name: item?.[0]?.game_name,
      type: 'bar',
      data: dataArr,
    }
  }) || []
  return chartData
};

const getRetentionTrendsChartData = (dataList, isDayOrWeek) => {
  const timeStr = isDayOrWeek ? 'YYYY-MM-DD' : 'YYYY-MM';
  const chartData = dataList?.map(item => {
    const dataArr = item?.list?.map(items => { return { x: moment(items.date).format(timeStr), y: items?.value } }) || [];
    return {
      name: item?.game_name,
      type: 'bar',
      data: dataArr,
    }
  }) || []
  return chartData
};

const getRetentionTrendsTableData = (dataList, isDayOrWeek) => {
  const timeStr = isDayOrWeek ? 'YYYY-MM-DD' : 'YYYY-MM';
  const tabletData: any = []
  dataList?.map(item => {
    item?.list?.map(items => {
      items.date = nullToRung(items?.date) === '-' ? '-' : moment(items?.date || '').format(timeStr)
      tabletData.push({
        ...items,
        value: nullToRung(items.value) !== '-' ? formatVal(items?.value, '0.00%') : '-',
        game_name: item?.game_name || ''
      })
    })
  }) || []
  return DateSort(tabletData)
};

const getRetentionTrendsDownloadData = (dataList, isDayOrWeek) => {
  const timeStr = isDayOrWeek ? 'YYYY-MM-DD' : 'YYYY-MM';
  const tabletData: any = []
  dataList?.map(item => {
    item?.list?.map(items => {
      items.date = nullToRung(items?.date) === '-' ? '-' : moment(items?.date || '').format(timeStr)
      tabletData.push({
        ...items,
        value: nullToRung(items.value) !== '-' ? formatExeclNormalPercent(items?.value) : '-',
        game_name: item?.game_name || ''
      })
    })
  }) || []
  return DateSort(tabletData)
};

const getTrendsTableData = (dataList, isDayOrWeek, switchDatePicker, isInit = false) => {
  const timeStr = isDayOrWeek ? 'YYYY-MM-DD' : 'YYYY-MM';
  const tabletData: any = []
  dataList.forEach(item => {
    tabletData.push({
      ...item,
      value: nullToRung(item.value) !== '-' ? formatVal(item.value, isInit ? '0' : '0.00') : '-',
      game_name: nullToRung(item.game_name)
    })
    if (!switchDatePicker) {
      tabletData.date = nullToRung(item?.date) === '-' ? '-' : moment(item?.date || '').format(timeStr)
    }
  });
  return DateSort(tabletData, switchDatePicker);
};

const getTrendsDownloadData = (dataList, isDayOrWeek, switchDatePicker, isInit = false) => {
  const timeStr = isDayOrWeek ? 'YYYY-MM-DD' : 'YYYY-MM';
  const tabletData: any = []
  dataList.forEach(item => {
    tabletData.push({
      ...item,
      value: nullToRung(item.value) !== '-' ? formatExeclCommon(item.value, isInit) : '-',
      game_name: nullToRung(item.game_name)
    })
    if (!switchDatePicker) {
      tabletData.date = nullToRung(item?.date) === '-' ? '-' : moment(item?.date || '').format(timeStr)
    }
  });
  return DateSort(tabletData, switchDatePicker);
};

function DateSort(obj, switchDatePicker = false) {
  obj.sort((a, b) => {
    if (!switchDatePicker) {
      let t1 = new Date(Date.parse(a.date.replace(/-/g, "/")))
      let t2 = new Date(Date.parse(b.date.replace(/-/g, "/")))
      return t1.getTime() - t2.getTime()
    } else {
      let t1 = a.date.replace(/[D,M]/g, "")
      let t2 = b.date.replace(/[D,M]/g, "")
      return t1 - t2
    }
  })
  return obj
}

export {
  getChartAndTableOpt,
  getTrendsChartData,
  getRetentionTrendsChartData,
  getRetentionTrendsTableData,
  getRetentionTrendsDownloadData,
  getTrendsTableData,
  getTrendsDownloadData
}
